/** 앱 UI·i18next·백엔드 lang 쿠키 공통 지원 언어 */
export const SUPPORTED_APP_LANGUAGES = ['ko', 'en'];

/** @param {string|null|undefined} raw */
export function normalizeAppLanguage(raw) {
  if (raw == null || raw === '') return null;
  const primary = String(raw).trim().toLowerCase().split(/[-_]/)[0];
  if (primary === 'en') return 'en';
  if (primary === 'ko') return 'ko';
  return null;
}

/** i18next(ko/en) → themeConfig.locale(kor/eng) */
export function i18nLangToThemeLocale(lang) {
  return lang === 'en' ? 'eng' : 'kor';
}

/** Spring CookieLocaleResolver(lang) 와 동기화 */
export function setLangCookie(lang) {
  if (typeof document === 'undefined') return;
  const normalized = normalizeAppLanguage(lang) || 'ko';
  const maxAge = 60 * 60 * 24 * 365;
  document.cookie = `lang=${normalized};path=/;max-age=${maxAge};SameSite=Lax`;
}

/** 현재 URL search 에서 lang 파라미터 */
export function getLangFromUrl(search = '') {
  if (typeof window === 'undefined' && !search) return null;
  const qs = search || (typeof window !== 'undefined' ? window.location.search : '');
  return normalizeAppLanguage(new URLSearchParams(qs).get('lang'));
}

export function getStoredAppLanguage() {
  try {
    const stored = localStorage.getItem('i18nextLng');
    if (stored && SUPPORTED_APP_LANGUAGES.includes(stored)) {
      return stored;
    }
  } catch {
    // ignore
  }
  return null;
}

export function detectBrowserAppLanguage() {
  if (typeof navigator === 'undefined') return null;
  const candidates = navigator.languages?.length ? navigator.languages : [navigator.language];
  for (const raw of candidates) {
    const normalized = normalizeAppLanguage(raw);
    if (normalized) return normalized;
  }
  return null;
}

export function resolveInitialAppLanguage(search = '') {
  return (
    getLangFromUrl(search) ??
    getStoredAppLanguage() ??
    detectBrowserAppLanguage() ??
    'ko'
  );
}

/** lang 쿼리를 반영한 URL (다른 쿼리 유지) */
export function buildUrlWithLangParam(pathname, search, lang) {
  const params = new URLSearchParams(search || '');
  const normalized = normalizeAppLanguage(lang);
  if (normalized) {
    params.set('lang', normalized);
  } else {
    params.delete('lang');
  }
  const qs = params.toString();
  return qs ? `${pathname}?${qs}` : pathname;
}
